import { ReactComponent as FooterLogo } from "../assets/Smart_Pocket_V2_Logo_Web_200x40px.svg";

const FooterImage = () => {
	return (
		<div className="grid place-items-center w-40 md:w-72 ">
			<FooterLogo />
		</div>
	);
};

export { FooterImage };
